export const __WORKSPACE_NAME = '@peachy/geo-location-client'

export * from './src/GeoLocationServiceClient'
        import * as me from '@peachy/geo-location-client'
        
        Object.entries(me).forEach(([exportedAs, exported]) => {
            if (exported && Object.isExtensible(exported)) {
                exported[Symbol.for('__WORKSPACE_HOME')] = '/Users/dan-parker/workspace/peachy-repo/comp-kit/geo-location/client'
                exported[Symbol.for('__WORKSPACE_NAME')] = '@peachy/geo-location-client'
                exported[Symbol.for('__EXPORTED_AS')] = exportedAs
            }
        })
    